export const prevButtons = () => {

    const prevButtons = document.querySelectorAll('.pw-prev-button');
  
    prevButtons.forEach(function(prevButton) {
      prevButton.addEventListener('click', function(event) {
        if (history.length > 1 && document.referrer === window.location.origin + '/') {
          event.preventDefault();
          history.back();
        }
      });
    });

}
